import EventBus from './../../event-bus'

export default {
  beforeCreate () {
    this._data = {
      componentNotReady: true,
      componentHidden: true
    }
  },
  beforeMount () {
    this._data.componentNotReady = true
    this._data.componentHidden = true
  },
  mounted () {
    EventBus.$once('LoaderAnim.ANIM_END', this.onLoadAnimEnd)
  },
  beforeDestroy () {
    EventBus.$off('LoaderAnim.ANIM_END', this.onLoadAnimEnd)
  },
  data () {
    return this._data
  },
  methods: {
    onLoadAnimEnd (e) {
      e.clearAnim()
      let vm = this
      setTimeout(function () {
        vm._data.componentNotReady = false
        setTimeout(function () {
          vm._data.componentHidden = false
        }, 50)
      }, 50)
    }
  }
}
